/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';

type PropsType = {
  isSetConversionTrackingCode: boolean,
  facebookConversionTrackingCode: string,
  handleChangeInput: () => void,
  handleControlConversationTrackingCode: () => void
};

const Conversation = ({
  isSetConversionTrackingCode,
  facebookConversionTrackingCode,
  handleChangeInput,
  handleControlConversationTrackingCode
}: PropsType): React.Element<typeof React.Element> => {
  const [convCode, setConvCode] = React.useState(facebookConversionTrackingCode);

  return (
    <CollapsedPanel
      status={isSetConversionTrackingCode}
      title='Add conversation tracking code'
      onChange={(status: boolean): any => handleControlConversationTrackingCode(status)}
    >
      <div className="form-group SimpleInput">
        <label>Tracking Code</label>
        <textarea
          className="form-control"
          rows="6"
          value={convCode}
          onChange={(e: any) => {
            setConvCode(e.target.value);
          }}
          onBlur={() => {
            handleChangeInput({
              target: {
                name: 'facebook_conversion_tracking_code',
                value: convCode
              }
            });
          }}
          style={{
            resize: 'vertical'
          }}
        />
      </div>
    </CollapsedPanel>
  );
};

export default Conversation;
